import { Icon } from "@chakra-ui/react";

export default function Bluetooth(props) {
  return (
    <Icon
      width={["15px", null, "28px"]}
      height={["24px", null, "48px"]}
      viewBox="0 0 28 48"
      {...props}
    >
      <path
        fill="currentColor"
        d="M27.1296709,10.8390564 C27.1296709,10.6192543 27.0237365,10.4139189 26.8445347,10.2869844 L12.536861,0.125217979 C12.3305923,-0.0213167918 12.058523,-0.0404503129 11.8335874,0.0757508274 C11.6091186,0.191951968 11.4667838,0.42482092 11.4667838,0.677756735 L11.4667838,19.6768765 L2.00549098,12.9577439 C1.70028798,12.7412084 1.27748383,12.8130758 1.06094838,13.1178121 C0.844412918,13.4230151 0.915813619,13.8458193 1.22101661,14.0623547 L10.975379,20.9886894 L1.22101661,27.9154907 C0.915813619,28.1320261 0.844412918,28.5548303 1.06094838,28.8600333 C1.27748383,29.1652363 1.70028798,29.236637 2.00549098,29.0201015 L11.4677172,22.3009689 L11.4677172,41.3229556 C11.4677172,41.5758914 11.6095852,41.8087604 11.8345208,41.9249615 C12.0589896,42.0411626 12.3315256,42.0215624 12.5377943,41.8754943 L26.8450014,31.7141946 C27.0242032,31.5867934 27.1301375,31.3819247 27.1301375,31.1621225 C27.1301375,30.9423204 27.0242032,30.736985 26.8450014,30.6100505 L13.3236687,20.9966228 L26.8445347,11.3915952 C27.0232698,11.264194 27.1296709,11.0588586 27.1296709,10.8390564 Z M25.2825861,31.1616559 L12.8224638,40.0111427 L12.8224638,22.3023689 L25.2825861,31.1616559 Z M12.8219971,19.6908766 L12.8219971,1.98956961 L25.2821194,10.8390564 L12.8219971,19.6908766 Z"
        id="Shape"
      />
    </Icon>
  );
}
